
[
  {
    "id": "TG-E6P-L106-001",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Hoeveel kwartalen zitten er in 2 jaar?",
    "options": ["8", "4", "6", "12"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_schrikkel",
    "familyId": "TG-KWARTAAL",
    "explanation": "Een jaar heeft 4 kwartalen. 2 jaar heeft dus 2 × 4 = 8 kwartalen.",
    "distractorExplanations": { "1": "Dat is 1 jaar.", "2": "Dat is 1,5 jaar.", "3": "Dat zijn maanden." }
  },
  {
    "id": "TG-E6P-L106-002",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Je koopt 3 boeken van € 12,95 per stuk. Je betaalt met € 50. Hoeveel krijg je terug?",
    "options": ["€ 11,15", "€ 10,15", "€ 12,15", "€ 11,05"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "TG-BOEKEN-WISSELGELD",
    "explanation": "3 × 12,95 = 38,85. 50,00 - 38,85 = 11,15.",
    "distractorExplanations": { "1": "Rekenfout bij het aftrekken.", "2": "Rekenfout bij het vermenigvuldigen.", "3": "Rekenfout bij de centen." }
  },
  {
    "id": "TG-E6P-L106-003",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Het is 08:45. De trein vertrekt over 1 uur en 25 minuten. Hoe laat vertrekt de trein?",
    "options": ["10:10", "10:00", "09:10", "10:20"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-TREIN-VERTREK",
    "explanation": "08:45 + 1 uur = 09:45. + 15 min = 10:00. + 10 min = 10:10.",
    "distractorExplanations": { "1": "10 minuten vergeten.", "2": "Uur vergeten.", "3": "10 minuten te veel." }
  },
  {
    "id": "TG-E6P-L106-004",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Hoeveel weken is 35 dagen?",
    "options": ["5 weken", "4 weken", "6 weken", "7 weken"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_basis",
    "familyId": "TG-DAGEN-WEKEN",
    "explanation": "Een week heeft 7 dagen. 35 : 7 = 5 weken.",
    "distractorExplanations": { "1": "4 × 7 = 28.", "2": "6 × 7 = 42.", "3": "7 × 7 = 49." }
  },
  {
    "id": "TG-E6P-L106-005",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Wat is goedkoper per stuk? 4 voor € 5,00 of 5 voor € 6,00?",
    "options": ["5 voor € 6,00", "4 voor € 5,00", "Even duur", "Niet te berekenen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "TG-PRIJS-VGL",
    "explanation": "4 voor 5 = € 1,25 per stuk. 5 voor 6 = € 1,20 per stuk. Dus 5 voor 6 is goedkoper.",
    "distractorExplanations": { "1": "Dat is € 1,25 per stuk.", "2": "Nee, er zit 5 cent verschil in.", "3": "Jawel, reken terug naar 1 stuk." }
  },
  {
    "id": "TG-E6P-L106-006",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Een concert begint om 20:15 en duurt 2 uur en 45 minuten. Hoe laat is het afgelopen?",
    "options": ["23:00", "22:45", "23:15", "22:00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-CONCERT-EIND",
    "explanation": "20:15 + 2 uur = 22:15. + 45 min = 23:00.",
    "distractorExplanations": { "1": "Je vergat de 15 minuten van de starttijd.", "2": "Je telde 15 minuten te veel.", "3": "Je vergat de 45 minuten." }
  },
  {
    "id": "TG-E6P-L106-007",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Je koopt 2 broodjes van € 1,85 en een sap van € 2,30. Hoeveel betaal je?",
    "options": ["€ 6,00", "€ 5,70", "€ 6,30", "€ 5,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "TG-LUNCH-TOTAAL",
    "explanation": "2 × 1,85 = 3,70. Plus 2,30 = 6,00.",
    "distractorExplanations": { "1": "Je deed 2 × 1,85 verkeerd.", "2": "Je telde 30 cent te veel.", "3": "Je vergat het sap." }
  },
  {
    "id": "TG-E6P-L106-008",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Hoeveel dagen heeft februari in een schrikkeljaar?",
    "options": ["29 dagen", "28 dagen", "30 dagen", "31 dagen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_schrikkel",
    "familyId": "TG-SCHRIKKELJAAR",
    "explanation": "In een schrikkeljaar heeft februari 29 dagen (normaal 28).",
    "distractorExplanations": { "1": "Dat is in een gewoon jaar.", "2": "Februari heeft nooit 30 dagen.", "3": "Februari heeft nooit 31 dagen." }
  },
  {
    "id": "TG-E6P-L106-009",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Wat is goedkoper per kg? 2 kg voor € 3,00 of 3 kg voor € 4,20?",
    "options": ["3 kg voor € 4,20", "2 kg voor € 3,00", "Even duur", "Niet te berekenen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "TG-PRIJS-VGL-KG",
    "explanation": "2 kg voor 3 = € 1,50/kg. 3 kg voor 4,20 = € 1,40/kg. Dus 3 kg voor 4,20 is goedkoper.",
    "distractorExplanations": { "1": "Dat is € 1,50 per kg.", "2": "Er zit 10 cent per kg verschil.", "3": "Je kunt het berekenen door te delen." }
  },
  {
    "id": "TG-E6P-L106-010",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Hoeveel uur is 180 minuten?",
    "options": ["3 uur", "2 uur", "2,5 uur", "4 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-MIN-UUR-180",
    "explanation": "180 : 60 = 3. Dus 180 minuten is 3 uur.",
    "distractorExplanations": { "1": "2 × 60 = 120, niet 180.", "2": "2,5 × 60 = 150, niet 180.", "3": "4 × 60 = 240, niet 180." }
  },
  {
    "id": "TG-E6P-L106-011",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Je betaalt € 23,45 met een biljet van € 50. Hoeveel krijg je terug?",
    "options": ["€ 26,55", "€ 27,55", "€ 26,45", "€ 36,55"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "TG-WISSELGELD-50",
    "explanation": "50,00 - 23,45 = 26,55.",
    "distractorExplanations": { "1": "Rekenfout bij de centen.", "2": "Rekenfout bij de centen.", "3": "Rekenfout bij de tientallen." }
  },
  {
    "id": "TG-E6P-L106-012",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Hoeveel dagen zitten er in 3 weken en 4 dagen?",
    "options": ["25 dagen", "24 dagen", "21 dagen", "28 dagen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_basis",
    "familyId": "TG-WEKEN-DAGEN",
    "explanation": "3 weken = 3 × 7 = 21 dagen. Plus 4 = 25 dagen.",
    "distractorExplanations": { "1": "Je deed 3 × 7 + 3.", "2": "Je vergat de 4 extra dagen.", "3": "Je deed 4 × 7." }
  },
  {
    "id": "TG-E6P-L106-013",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Een treinreis duurt van 14:35 tot 16:20. Hoe lang duurt de reis?",
    "options": ["1 uur en 45 minuten", "2 uur en 15 minuten", "1 uur en 55 minuten", "2 uur en 45 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-TREINREIS-DUUR",
    "explanation": "Van 14:35 naar 15:35 = 1 uur. Van 15:35 naar 16:20 = 45 min. Samen 1 uur 45 min.",
    "distractorExplanations": { "1": "Rekenfout bij de minuten.", "2": "Rekenfout bij de minuten.", "3": "Rekenfout bij de uren." }
  },
  {
    "id": "TG-E6P-L106-014",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Je spaart € 15 per maand. Na hoeveel maanden heb je € 90?",
    "options": ["6 maanden", "5 maanden", "7 maanden", "9 maanden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "TG-SPAREN-DOEL",
    "explanation": "90 : 15 = 6. Na 6 maanden heb je € 90.",
    "distractorExplanations": { "1": "5 × 15 = 75, niet 90.", "2": "7 × 15 = 105, dat is te veel.", "3": "9 × 15 = 135, dat is veel te veel." }
  },
  {
    "id": "TG-E6P-L106-015",
    "module": "TijdGeld",
    "difficulty": 106,
    "question": "Hoeveel kwartalen zitten er in 3 jaar?",
    "options": ["12", "9", "6", "15"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_schrikkel",
    "familyId": "TG-KWARTAAL-3JAAR",
    "explanation": "1 jaar = 4 kwartalen. 3 × 4 = 12 kwartalen.",
    "distractorExplanations": { "1": "Dat is 3 × 3.", "2": "Dat is 3 × 2.", "3": "Dat is 3 × 5." }
  }
]
